/* External dependencies */
import { gql } from '@apollo/client';

export const getSignedUrlsQuery = gql`
  query getSignedUrls($input: GetSignedUrlsInput!) {
    getSignedUrls(input: $input) {
      signedUrls {
        signedUrl
        url
      }
    }
  }
`;
